import React, { useEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import { Button, Grid, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import CropFreeIcon from "@mui/icons-material/CropFree";
import MicIcon from "@mui/icons-material/Mic";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ShuffleIcon from "@mui/icons-material/Shuffle";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import UploadOutlinedIcon from "@mui/icons-material/UploadOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import phonebody from "../../../../assets/images/phonebody.png";
import zglass from "../../../../assets/images/zglass.png";
import zimg from "../../../../assets/images/zimg.png";
import homeicon from "../../../../assets/images/homeicon.png";

const Wrapper = styled.section`
  width: 100%;
  padding: 180px 0px 410px 0px;
  position: relative;
  overflow: hidden;

  @media (max-width: 900px) {
    padding: 80px 0px 60px;
  }

  @media (max-width: 520px) {
    padding: 60px 0px 40px;
  }
`;

const Inner = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  position: relative;
  padding: 0 24px;

  @media (max-width: 900px) {
    padding: 0 20px;
  }
`;

const Title = styled(Typography)`
  color: #000;
  font-size: 72px;
  line-height: normal;
  font-family: "primary1" !important;
  text-align: left;
  position: relative;
  z-index: 2;

  @media (max-width: 900px) {
    font-size: 48px;
  }

  @media (max-width: 520px) {
    font-size: 36px;
  }
`;

const TitleSmall = styled(Typography)`
  color: #000;
  font-size: 30px;
  line-height: normal;
  font-family: "primary1" !important;
  text-align: left;
  margin-top: 35px;
  position: relative;
  z-index: 2;

  @media (max-width: 900px) {
    font-size: 24px;
    margin-top: 24px;
  }

  @media (max-width: 520px) {
    font-size: 20px;
    margin-top: 18px;
  }
`;

const Intro = styled(Typography)`
  color: #000000;
  font-size: 21px;
  line-height: 1.25;
  text-align: left;
  max-width: 540px;
  margin: 20px 0 0;

  @media (max-width: 900px) {
    font-size: 16px;
    max-width: 100%;
  }

  @media (max-width: 520px) {
    font-size: 14px;
    margin-top: 16px;
  }
`;

const Introsmall = styled(Typography)`
  color: #000000;
  font-size: 18px;
  line-height: 1.25;
  text-align: left;
  max-width: 480px;
  margin: 10px 0 0;

  @media (max-width: 900px) {
    max-width: 100%;
    font-size: 15px;
  }

  @media (max-width: 520px) {
    font-size: 14px;
    margin-top: 8px;
  }
`;

const ComingSoon = styled(Button)`
  background-color: #f0f0f0 !important;
  padding: 8px 16px !important;
  color: #71717b !important;
  font-size: 15px !important;
  font-family: "primary1" !important;
  margin-top: 24px !important;
  border-radius: 6px !important;
  text-transform: none !important;
`;

const MobileImageWrapper = styled.div`
  position: absolute;
  right: 350px;
  top: 60%;
  transform: translateY(-50%);
  width: 100%;
  max-width: 400px;
  z-index: 1;

  @media (max-width: 1200px) {
    right: 20px;
    max-width: 420px;
  }

  @media (max-width: 900px) {
    display: none;
  }
`;

const MobileImageSmallWrapper = styled.div`
  display: none;

  @media (max-width: 900px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 40px;
    padding: 0 20px;
  }

  @media (max-width: 520px) {
    margin-top: 28px;
    padding: 0 10px;
  }
`;

const PhoneShell = styled("div", {
  shouldForwardProp: (prop) => prop !== "live",
})`
  position: relative;
  width: 100%;
  max-width: 470px;
  aspect-ratio: 470 / 973;
  filter: drop-shadow(0 24px 35px rgba(20, 32, 36, 0.16));
  transform: translateY(${(props) => (props.live ? "0" : "8px")});
  transition: transform 0.45s ease;

  &::after {
    content: "";
    position: absolute;
    left: 11%;
    right: 11%;
    bottom: 7.2%;
    height: 120px;
    border-radius: 22px;
    background: radial-gradient(circle at 50% 65%, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0) 62%);
    opacity: ${(props) => (props.live ? 1 : 0)};
    pointer-events: none;
    animation: ${(props) => (props.live ? "usableGlow 2.8s ease-in-out infinite" : "none")};
  }

  @keyframes usableGlow {
    0%, 100% {
      opacity: 0.18;
      transform: scale(0.98);
    }

    50% {
      opacity: 0.34;
      transform: scale(1.02);
    }
  }

  @media (max-width: 520px) {
    max-width: 330px;
  }
`;

const PhoneBody = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  user-select: none;
  pointer-events: none;
`;

const PhoneScreen = styled.div`
  position: absolute;
  left: 7.5%;
  right: 7.5%;
  top: 5.1%;
  bottom: 5.4%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 34px;
  color: #171717;
  font-family: "primary1", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;

  @media (max-width: 520px) {
    border-radius: 26px;
  }
`;

const TopChrome = styled.div`
  display: grid;
  grid-template-columns: 26px 1fr 24px 34px 22px;
  align-items: center;
  gap: 10px;
  padding: 28px 24px 8px;
  color: #8d929b;
  font-size: 10px;
  flex: 0 0 auto;

  svg {
    width: 18px;
    height: 18px;
  }

  @media (max-width: 520px) {
    grid-template-columns: 22px 1fr 20px 30px 18px;
    gap: 7px;
    padding: 20px 17px 6px;
    font-size: 8px;

    svg {
      width: 15px;
      height: 15px;
    }
  }
`;

const BrowserSearch = styled.div`
  min-width: 0;
  height: 34px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 9px 24px rgba(35, 48, 55, 0.08);
  color: #9da1a8;
  white-space: nowrap;
  overflow: hidden;

  span:first-of-type {
    display: grid;
    place-items: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #858993;
    color: #fff;
    font-size: 12px;
    flex: 0 0 auto;
  }

  span:last-of-type {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (max-width: 520px) {
    height: 28px;
    padding: 0 8px;
    gap: 6px;

    span:first-of-type {
      width: 17px;
      height: 17px;
      font-size: 10px;
    }
  }
`;

const CountPill = styled.div`
  height: 28px;
  min-width: 20px;
  display: grid;
  place-items: center;
  border: 1px solid #c7cbd1;
  border-radius: 12px;
  color: #8c929b;
  font-size: 11px;

  @media (max-width: 520px) {
    height: 24px;
    min-width: 24px;
    border-radius: 8px;
    font-size: 9px;
  }
`;

const ContentArea = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  padding: 8px 24px 10px;
  overflow: hidden;

  @media (max-width: 520px) {
    padding: 6px 17px 8px;
  }
`;

const AgentPanel = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 0;
`;

const HeroLogo = styled.img`
  width: 116px;
  height: 116px;
  object-fit: contain;
  margin-top: 58px;
  filter: drop-shadow(0 14px 18px rgba(0, 0, 0, 0.1));
  animation: zglassAlive 3.2s ease-in-out infinite;

  @keyframes zglassAlive {
    0%, 100% {
      transform: translateY(0) rotate(-2deg) scale(1);
      filter: drop-shadow(0 14px 18px rgba(0, 0, 0, 0.1));
    }

    50% {
      transform: translateY(-8px) rotate(3deg) scale(1.04);
      filter: drop-shadow(0 20px 24px rgba(0, 0, 0, 0.16));
    }
  }

  @media (max-width: 520px) {
    width: 82px;
    height: 82px;
    margin-top: 38px;
  }
`;

const Greeting = styled.div`
  text-align: center;
  margin-top: 8px;

  p {
    margin: 0 0 4px;
    font-size: 17px;
    color: #3d3f42;
  }

  h3 {
    margin: 0;
    font-size: 28px;
    line-height: 1.05;
    color: #101113;
  }

  @media (max-width: 520px) {
    p {
      font-size: 12px;
    }

    h3 {
      font-size: 20px;
    }
  }
`;

const TypewriterText = styled.p`
  display: inline-block;
  min-height: 0;
  margin: 0;

  &::after {
    content: "";
    display: inline-block;
    width: 1px;
    height: 1em;
    margin-left: 3px;
    background: #3d3f42;
    transform: translateY(2px);
    animation: typeCaret 0.85s steps(1) infinite;
  }

  @keyframes typeCaret {
    0%, 50% {
      opacity: 1;
    }

    51%, 100% {
      opacity: 0;
    }
  }
`;

const ChatList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
  padding-bottom: 8px;
  overflow-y: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const ChatBubble = styled("div", {
  shouldForwardProp: (prop) => prop !== "from",
})`
  max-width: 82%;
  align-self: ${(props) => (props.from === "user" ? "flex-end" : "flex-start")};
  padding: 9px 12px;
  border-radius: ${(props) => (props.from === "user" ? "16px 16px 5px 16px" : "16px 16px 16px 5px")};
  background: ${(props) => (props.from === "user" ? "#111" : "rgba(255, 255, 255, 0.86)")};
  color: ${(props) => (props.from === "user" ? "#fff" : "#202124")};
  // box-shadow: 0 10px 24px rgba(35, 48, 55, 0.08);
  font-size: 13px;
  line-height: 1.25;

  @media (max-width: 520px) {
    font-size: 10px;
    padding: 7px 9px;
  }
`;

const Dashboard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  padding-top: 36px;

  @media (max-width: 520px) {
    gap: 9px;
    padding-top: 24px;
  }
`;

const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  strong {
    font-size: 24px;
    line-height: 1;
  }

  span {
    display: block;
    margin-top: 5px;
    color: #777d86;
    font-size: 12px;
  }

  @media (max-width: 520px) {
    gap: 9px;

    strong {
      font-size: 17px;
    }

    span {
      font-size: 9px;
    }
  }
`;

const HeaderIcon = styled.div`
  width: 48px;
  height: 48px;
  display: grid;
  place-items: center;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 12px 26px rgba(31, 45, 52, 0.09);

  svg {
    width: 24px;
    height: 24px;
  }

  @media (max-width: 520px) {
    width: 36px;
    height: 36px;
    border-radius: 12px;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

const GlassCard = styled.div`
  padding: 16px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0 16px 34px rgba(28, 44, 55, 0.1);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);

  @media (max-width: 520px) {
    padding: 12px;
    border-radius: 15px;
  }
`;

const Balance = styled.div`
  font-size: 30px;
  line-height: 1;
  margin-top: 10px;

  span {
    font-size: 13px;
    color: #7c828b;
    margin-left: 5px;
  }

  @media (max-width: 520px) {
    font-size: 22px;

    span {
      font-size: 10px;
    }
  }
`;

const StatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
`;

const MiniStat = styled(GlassCard)`
  min-height: 72px;

  p {
    margin: 0;
    font-size: 11px;
    color: #7d838c;
  }

  strong {
    display: block;
    margin-top: 8px;
    font-size: 18px;
  }

  @media (max-width: 520px) {
    min-height: 54px;

    p {
      font-size: 8px;
    }

    strong {
      margin-top: 5px;
      font-size: 13px;
    }
  }
`;

const RouteCard = styled(GlassCard)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const RouteRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 44px;
  padding: 0 12px;
  border-radius: 14px;
  background: rgba(246, 248, 250, 0.78);
  font-size: 13px;

  span {
    color: #8a9099;
  }

  @media (max-width: 520px) {
    min-height: 34px;
    padding: 0 9px;
    border-radius: 11px;
    font-size: 10px;
  }
`;

const MixerProgress = styled.div`
  height: 8px;
  border-radius: 999px;
  background: rgba(215, 222, 228, 0.82);
  overflow: hidden;

  span {
    display: block;
    width: 68%;
    height: 100%;
    border-radius: inherit;
    background: linear-gradient(90deg, #111, #7f8a92);
  }
`;

const ToolScreen = styled.div`
  height: 100%;
  margin: -8px -24px -10px;
  background: transparent;
  overflow-y: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 520px) {
    margin: -6px -17px -8px;
  }
`;

const ToolHeader = styled.div`
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 15px;
  border-bottom: 1px solid #575d64;
  background: rgba(255, 255, 255, 0.42);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  color: #33363a;

  div {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }

  strong {
    font-size: 20px;
    line-height: 1;
  }

  svg {
    width: 18px;
    height: 18px;
    flex: 0 0 auto;
  }

  @media (max-width: 520px) {
    height: 50px;
    padding: 0 11px;

    div {
      gap: 7px;
    }

    strong {
      font-size: 14px;
    }

    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

const ToolBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 15px 90px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  color: #292d31;

  @media (max-width: 520px) {
    gap: 10px;
    padding: 14px 11px 70px;
  }
`;

const ToolCard = styled.div`
  border: 1px solid #6b7178;
  border-radius: 8px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.34);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);

  @media (max-width: 520px) {
    border-radius: 6px;
    padding: 11px;
  }
`;

const ToolTitle = styled.strong`
  display: block;
  font-family: "primary1", system-ui, sans-serif;
  font-size: 16px;
  margin-bottom: 6px;

  @media (max-width: 520px) {
    font-size: 11px;
    margin-bottom: 4px;
  }
`;

const ToolText = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 1.55;

  @media (max-width: 520px) {
    font-size: 8px;
  }
`;

const FieldLabel = styled.label`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
  color: #676d74;
  font-family: "primary1", system-ui, sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;

  @media (max-width: 520px) {
    margin-bottom: 6px;
    font-size: 8px;
  }
`;

const FormField = styled.div`
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border: 1px solid #6b7178;
  border-radius: 6px;
  padding: 0 12px;
  background: rgba(255, 255, 255, 0.38);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  color: #24282c;
  font-size: 12px;

  svg {
    width: 15px;
    height: 15px;
  }

  @media (max-width: 520px) {
    min-height: 32px;
    border-radius: 5px;
    padding: 0 9px;
    font-size: 8px;

    svg {
      width: 11px;
      height: 11px;
    }
  }
`;

const MutedBox = styled("div", {
  shouldForwardProp: (prop) => prop !== "center",
})`
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: ${(props) => props.center ? "center" : "space-between"};
  gap: 10px;
  padding: 0 12px;
  border-radius: 6px;
  background: rgba(241, 242, 244, 0.52);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  color: #666d75;
  font-size: 12px;

  strong {
    color: #111;
  }

  @media (max-width: 520px) {
    min-height: 32px;
    padding: 0 9px;
    font-size: 8px;
  }
`;

const SolidAction = styled("button", {
  shouldForwardProp: (prop) => prop !== "muted",
})`
  min-height: 50px;
  border: 0;
  border-radius: 8px;
  background: ${(props) => props.muted ? "#929292" : "#111"};
  color: #fff;
  font-family: "primary1", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 700;

  svg {
    width: 17px;
    height: 17px;
    margin-right: 8px;
    vertical-align: middle;
  }

  @media (max-width: 520px) {
    min-height: 36px;
    border-radius: 6px;
    font-size: 10px;

    svg {
      width: 12px;
      height: 12px;
      margin-right: 6px;
    }
  }
`;

const WalletBalanceCard = styled(ToolCard)`
  position: relative;
  text-align: center;
  padding: 22px 15px;

  .refresh {
    position: absolute;
    right: 12px;
    top: 12px;
    color: #7c8289;
  }

  span {
    display: block;
    color: #676d74;
    font-size: 11px;
    letter-spacing: 0.14em;
    text-transform: uppercase;
  }

  h3 {
    margin: 10px 0 6px;
    font-size: 27px;
    line-height: 1;
  }

  p {
    margin: 0 0 14px;
    font-size: 12px;
  }

  button {
    min-height: 34px;
    min-width: 88px;
    border: 0;
    border-radius: 999px;
    background: #111;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
  }

  @media (max-width: 520px) {
    padding: 16px 11px;

    span {
      font-size: 8px;
    }

    h3 {
      margin: 7px 0 5px;
      font-size: 19px;
    }

    p,
    button {
      font-size: 8px;
    }

    button {
      min-height: 25px;
      min-width: 64px;
    }
  }
`;

const Composer = styled.form`
  flex: 0 0 auto;
  padding: 8px 24px 14px;

  @media (max-width: 520px) {
    padding: 6px 17px 10px;
  }
`;

const InputDock = styled("div", {
  shouldForwardProp: (prop) => prop !== "live",
})`
  min-height: 56px;
  display: grid;
  grid-template-columns: 26px 1fr 28px 38px 34px;
  align-items: center;
  gap: 9px;
  padding: 8px 10px 8px 14px;
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 12px 28px rgba(30, 41, 48, 0.12);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  position: relative;

  &::after {
    content: "";
    position: absolute;
    left: 53px;
    top: 50%;
    width: 1px;
    height: 18px;
    background: #151618;
    opacity: ${(props) => (props.live ? 1 : 0)};
    transform: translateY(-50%);
    pointer-events: none;
    animation: ${(props) => (props.live ? "inputCaretBlink 0.85s steps(1) infinite" : "none")};
  }

  @keyframes inputCaretBlink {
    0%, 50% {
      opacity: 1;
    }

    51%, 100% {
      opacity: 0;
    }
  }

  @media (max-width: 520px) {
    min-height: 42px;
    grid-template-columns: 19px 1fr 22px 30px 27px;
    gap: 6px;
    padding: 6px 7px 6px 10px;
    border-radius: 10px;

    &::after {
      left: 40px;
      height: 14px;
    }
  }
`;

const IconButton = styled("button", {
  shouldForwardProp: (prop) => prop !== "dark",
})`
  width: 100%;
  aspect-ratio: 1;
  display: grid;
  place-items: center;
  border: 0;
  padding: 0;
  border-radius: 50%;
  background: ${(props) => (props.dark ? "#111" : "transparent")};
  color: ${(props) => (props.dark ? "#fff" : "#8a9099")};
  cursor: pointer;
  transition: transform 0.16s ease, background 0.16s ease, color 0.16s ease;

  &:active {
    transform: scale(0.9);
  }

  svg {
    width: 17px;
    height: 17px;
  }

  @media (max-width: 520px) {
    svg {
      width: 13px;
      height: 13px;
    }
  }
`;

const MessageInput = styled.input`
  width: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #151618;
  font-size: 14px;
  font-family: inherit;

  &::placeholder {
    color: #858b94;
  }

  @media (max-width: 520px) {
    font-size: 10px;
  }
`;

const TabBar = styled("div", {
  shouldForwardProp: (prop) => prop !== "live",
})`
  flex: 0 0 auto;
  margin: 0 24px 20px;
  min-height: 82px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  padding: 10px;
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 16px 34px rgba(31, 45, 52, 0.12);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  animation: ${(props) => (props.live ? "tabWake 2.8s ease-in-out infinite" : "none")};

  @keyframes tabWake {
    0%, 100% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(-2px);
    }
  }

  @media (max-width: 520px) {
    margin: 0 17px 15px;
    min-height: 60px;
    gap: 7px;
    padding: 7px;
    border-radius: 10px;
  }
`;

const TabButton = styled("button", {
  shouldForwardProp: (prop) => prop !== "active" && prop !== "live",
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 0;
  border-radius: 11px;
  background: transparent;
  color: ${(props) => (props.active ? "#111" : "#7e858e")};
  font-size: 11px;
  font-family: inherit;
  cursor: pointer;
  transition: transform 0.16s ease, color 0.16s ease;
  animation: ${(props) => (props.live ? "tabClickHint 2.4s ease-in-out infinite" : "none")};
  animation-delay: ${(props) => (props.active ? "0s" : "0.35s")};

  &:active {
    transform: translateY(1px) scale(0.97);
  }

  .icon {
    width: 42px;
    height: 42px;
    display: grid;
    place-items: center;
    border-radius: 10px;
    background: ${(props) => (props.active ? "#111" : "rgba(246, 247, 249, 0.9)")};
    color: ${(props) => (props.active ? "#fff" : "#777d86")};
    box-shadow: ${(props) => (props.active ? "0 10px 20px rgba(0, 0, 0, 0.2)" : "none")};
  }

  @keyframes tabClickHint {
    0%, 100% {
      opacity: 1;
    }

    50% {
      opacity: 0.62;
    }
  }

  img,
  svg {
    width: 21px;
    height: 21px;
    object-fit: contain;
  }

  img {
    filter: ${(props) => (props.active ? "brightness(0) invert(1)" : "none")};
  }

  @media (max-width: 520px) {
    gap: 4px;
    border-radius: 8px;
    font-size: 8px;

    .icon {
      width: 31px;
      height: 31px;
      border-radius: 8px;
    }

    img,
    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

const tabs = [
  { id: "agent", label: "Agent" },
  { id: "wallet", label: "Wallet" },
  { id: "mixer", label: "Mixer" },
];

const tabIcon = (id) => {
  if (id === "agent") return <img src={zimg} alt="" aria-hidden="true" />;
  if (id === "wallet") return <AccountBalanceWalletOutlinedIcon />;
  return <ShuffleIcon />;
};

const FeaturePanel = ({ activeTab }) => {
  if (activeTab === "wallet") {
    return (
      <ToolScreen>
        <ToolHeader>
          <div>
            <AccountBalanceWalletOutlinedIcon />
            <strong>SESSION WALLET</strong>
          </div>
          <CloseIcon />
        </ToolHeader>
        <ToolBody>
          <ToolCard>
            <ToolTitle>Ephemeral Session Wallet</ToolTitle>
            <ToolText>
              This wallet exists only in memory. It is destroyed when the browser closes. Keep balances minimal.
            </ToolText>
          </ToolCard>

          <div>
            <FieldLabel>Wallet Address</FieldLabel>
            <FormField>
              <span style={{fontSize:'12px'}}>2gLwUFg22VfUk7gCGJRv5p1s2hBirKwsYvPHu7Pok</span>
              {/* <MutedBox>Copy</MutedBox> */}
            </FormField>
          </div>

          <WalletBalanceCard>
            <RefreshOutlinedIcon className="refresh" />
            <span>Balance</span>
            <h3>0 SOL</h3>
            <p>≈ $0.00</p>
            <button type="button"><SendRoundedIcon /> </button>
          </WalletBalanceCard>

          <div>
            <FieldLabel>
              <span>Tokens</span>
              <span>+ ↻</span>
            </FieldLabel>
            <MutedBox center>No tokens found</MutedBox>
          </div>

          <div>
            <FieldLabel>Network</FieldLabel>
            <FormField>
              <span>Solana</span>
              <span>⌄</span>
            </FormField>
          </div>

          <FormField>
            <span><FileDownloadOutlinedIcon /> Export Private Key</span>
          </FormField>
          <FormField>
            <span><UploadOutlinedIcon /> Import Wallet</span>
          </FormField>
        </ToolBody>
      </ToolScreen>
    );
  }

  if (activeTab === "mixer") {
    return (
      <ToolScreen>
        <ToolHeader>
          <div>
            <ShuffleIcon />
            <strong>Mixer</strong>
          </div>
          <CloseIcon />
        </ToolHeader>
        <ToolBody>
          <ToolCard>
            <ToolTitle><InfoOutlinedIcon /> How Mixer Works</ToolTitle>
            <ToolText>
              The mixer breaks deterministic flow by routing your transaction through multiple hops with randomized timing and amounts.
            </ToolText>
            <ToolText>• Optimized routing paths</ToolText>
            <ToolText>• Randomized timing delays</ToolText>
            <ToolText>• Amount obfuscation</ToolText>
          </ToolCard>

          <div>
            <FieldLabel>Exchange Pair</FieldLabel>
            <FormField><span>BTC → USDT (ERC20)</span><span>⌄</span></FormField>
          </div>

          <div>
            <FieldLabel><span>Amount</span><span>Min: 0.0000176 BTC</span></FieldLabel>
            <FormField>1</FormField>
          </div>

          <MutedBox>
            <span>Estimated to receive:</span>
            <strong>≈ 61820.573574 USDT</strong>
          </MutedBox>

          <div>
            <FieldLabel>Enter Receiving Wallet Address</FieldLabel>
            <FormField><span style={{ color: "#9aa0a7" }}>Enter Wallet Address</span></FormField>
          </div>

          <SolidAction type="button">Create Order</SolidAction>
        </ToolBody>
      </ToolScreen>
    );
  }

  return null;
};

const PhoneMockup = () => {
  const phoneRef = useRef(null);
  const [isLive, setIsLive] = useState(false);
  const [activeTab, setActiveTab] = useState("agent");
  const [inputMessage, setInputMessage] = useState("");
  const [typeText, setTypeText] = useState("");
  const [chatMessages, setChatMessages] = useState([
    { id: 1, from: "bot", text: "" },
  ]);
  const isAgent = activeTab === "agent";

  useEffect(() => {
    const phone = phoneRef.current;

    if (!phone) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsLive(true);
          observer.disconnect();
        }
      },
      { threshold: 0.35 }
    );

    observer.observe(phone);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isLive || !isAgent) return undefined;

    const phrases = ["How are you?", "Chat with me"];
    let phraseIndex = 0;
    let charIndex = 0;
    let deleting = false;
    let timeoutId;

    const tick = () => {
      const phrase = phrases[phraseIndex];
      setTypeText(phrase.slice(0, charIndex));

      if (!deleting && charIndex < phrase.length) {
        charIndex += 1;
        timeoutId = setTimeout(tick, 75);
        return;
      }

      if (!deleting) {
        deleting = true;
        timeoutId = setTimeout(tick, 900);
        return;
      }

      if (charIndex > 0) {
        charIndex -= 1;
        timeoutId = setTimeout(tick, 45);
        return;
      }

      deleting = false;
      phraseIndex = (phraseIndex + 1) % phrases.length;
      timeoutId = setTimeout(tick, 260);
    };

    charIndex = 1;
    setTypeText(phrases[0].slice(0, 1));
    timeoutId = setTimeout(tick, 75);

    return () => clearTimeout(timeoutId);
  }, [isAgent, isLive]);

  const sendMessage = (event) => {
    event.preventDefault();
    const text = inputMessage.trim();

    if (!text) return;

    setActiveTab("agent");
    setChatMessages((messages) => [
      ...messages,
      { id: Date.now(), from: "user", text },
      { id: Date.now() + 1, from: "bot", text: "Got it! I can help you with that." },
    ]);
    setInputMessage("");
  };

  return (
    <PhoneShell ref={phoneRef} live={isLive}>
      <PhoneBody src={phonebody} alt="Mobile app phone body" />
      <PhoneScreen>
        {isAgent && (
          <TopChrome>
            <img src={homeicon} alt="Home" style={{ width: 28, height: 28 }} />
            <BrowserSearch>
              <span>G</span>
              <span>Search Google or type a URL</span>
            </BrowserSearch>
            <AddIcon />
            <CountPill>01</CountPill>
            <MoreVertIcon />
          </TopChrome>
        )}

        <ContentArea>
          {isAgent ? (
            <AgentPanel>
              <HeroLogo src={zglass} alt="" aria-hidden="true" />
              <Greeting>
                {/* <p>Happy to see you, Buddy.</p> */}
                <h3>How can I help you?</h3>
              </Greeting>
              <ChatList>
                {chatMessages.map((message) => (
                  <ChatBubble key={message.id} from={message.from}>
                    {message.id === 1 ? <TypewriterText>{typeText}</TypewriterText> : message.text}
                  </ChatBubble>
                ))}
              </ChatList>
            </AgentPanel>
          ) : (
            <FeaturePanel activeTab={activeTab} />
          )}
        </ContentArea>

        {isAgent && (
          <Composer onSubmit={sendMessage}>
            <InputDock live={!inputMessage}>
              <IconButton type="button" aria-label="Add">
                <AddIcon />
              </IconButton>
              <MessageInput
                value={inputMessage}
                onChange={(event) => setInputMessage(event.target.value)}
                placeholder="Search now"
              />
              <IconButton type="button" aria-label="Scanner">
                <CropFreeIcon />
              </IconButton>
              <IconButton type="button" dark aria-label="Voice">
                <MicIcon />
              </IconButton>
              <IconButton type="submit" aria-label="Send">
                <SendRoundedIcon />
              </IconButton>
            </InputDock>
          </Composer>
        )}

        <TabBar live={isLive}>
          {tabs.map((tab) => (
            <TabButton
              type="button"
              key={tab.id}
              active={activeTab === tab.id}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="icon">{tabIcon(tab.id)}</span>
              <span>{tab.label}</span>
            </TabButton>
          ))}
        </TabBar>
      </PhoneScreen>
    </PhoneShell>
  );
};

const IOS = () => {
  return (
    <Wrapper>
      <MobileImageWrapper>
        <PhoneMockup />
      </MobileImageWrapper>

      <Inner>
        <Grid container>
          <Grid item xs={12} md={7}>
            <Title data-aos="fade-up" data-aos-delay="100">Mobile Apps <br />IOS & Android</Title>
            <Intro data-aos="fade-up" data-aos-delay="100">
              Experience Zephyr on the go with a powerful mobile agent built for private, autonomous Web3 interaction.
            </Intro>
            <ComingSoon data-aos="fade-up" data-aos-delay="100">Coming Soon</ComingSoon>

            <TitleSmall data-aos="fade-up" data-aos-delay="100">Ephemeral Wallet</TitleSmall>
            <Introsmall data-aos="fade-up" data-aos-delay="100">
              Disposable wallets created on-demand. No address reuse, no identity buildup.
            </Introsmall>

            <TitleSmall data-aos="fade-up" data-aos-delay="100">Your fav web 3.0 dapps</TitleSmall>
            <Introsmall data-aos="fade-up" data-aos-delay="100">
              Access and interact with leading Web3 applications through Zephyr Agent. Seamless execution, simplified workflows, and private interactions across your favorite platforms.
            </Introsmall>

            <TitleSmall data-aos="fade-up" data-aos-delay="100">Free in-app VPN</TitleSmall>
            <Introsmall data-aos="fade-up" data-aos-delay="100">
              Built-in privacy layer that secures your browsing and dApp interactions. Encrypt traffic and stay anonymous while using Web3 services.
            </Introsmall>

            <MobileImageSmallWrapper data-aos="fade-up" data-aos-delay="100">
              <PhoneMockup />
            </MobileImageSmallWrapper>
          </Grid>
        </Grid>
      </Inner>
    </Wrapper>
  );
};

export default IOS;
